module.exports = __webpack_public_path__ + "static/img/s1.9b94dc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s1.png
// module id = e4x9
// module chunks = 0